const TAG_MOBIL = {
	UNIKALNYE: "unikalnye",
};

export const getTagUnikalnye = (tarif) => {
	let tag = [];
	if (tarif.mobile_new.tag_mobil) {
		tarif.mobile_new.tag_mobil.forEach((element) => {
			tag.push(element.translit);
		});
	}
	return tag.includes(TAG_MOBIL.UNIKALNYE);
};
